export default __webpack_public_path__ + "static/media/promo-1.74b00711.png";